import { render, staticRenderFns } from "./ContainerPage.vue?vue&type=template&id=08a19c4a&scoped=true"
import script from "./ContainerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ContainerPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ContainerPage.vue?vue&type=style&index=0&id=08a19c4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a19c4a",
  null
  
)

export default component.exports